(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-dj"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {

  // 移除产品页 section 多余 padding
  const sectionEl = document.querySelector('.section--tight.section-full.bg-custom');
  if (sectionEl) {
    sectionEl.style.paddingTop = '10px';
    sectionEl.style.paddingBottom = '10px';
  }
  const productEl = document.querySelector('.section--tight.section-full.bg-custom .product');
  if (productEl) {
    productEl.style.paddingTop = '0';
    productEl.style.paddingBottom = '0';
  }

  // 图片计数器（仅移动端）
  if (window.innerWidth <= 999) {
    const wrapper = document.querySelector('.ulefone-dji-main');
    if (wrapper) {
      const imgs = wrapper.querySelectorAll('.ulefone-dji-slide');
      const total = imgs.length;
      if (total >= 1) {
        const counter = document.createElement('div');
        counter.className = 'ulefone-photo-counter';
        counter.textContent = '1/' + total;
        wrapper.appendChild(counter);
        // 默认只在 Photos 标签显示
const activeTab = document.querySelector('.ulefone-dji-tab.active');
if (activeTab && activeTab.dataset.view !== 'photos') {
  counter.style.display = 'none';
}

        // 滑动后更新计数
        let touchStartX = 0;
        wrapper.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
        wrapper.addEventListener('touchend', e => {
          const diff = touchStartX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) {
            setTimeout(() => {
              const activeSlide = wrapper.querySelector('.ulefone-dji-slide.active');
              if (activeSlide) {
                const index = Array.from(imgs).indexOf(activeSlide);
                counter.textContent = (index + 1) + '/' + total;
              }
            }, 350);
          }
        }, { passive: true });
      }
    }
  }

  // 图片轮播
  const slides = document.querySelectorAll('.ulefone-dji-slide');
  const thumbs = document.querySelectorAll('.ulefone-dji-thumb');
  const prev = document.querySelector('.ulefone-dji-arrow.prev');
  const next = document.querySelector('.ulefone-dji-arrow.next');
  const thumbnailsEl = document.getElementById('dji-thumbnails');
  let current = 0;

  function showSlide(index) {
    slides.forEach(el => el.classList.remove('active'));
    thumbs.forEach(el => el.classList.remove('active'));
    if (slides[index]) slides[index].classList.add('active');
    if (thumbs[index]) thumbs[index].classList.add('active');
    current = index;
    // 更新计数器
    const counter = document.querySelector('.ulefone-photo-counter');
    if (counter) counter.textContent = (index + 1) + '/' + slides.length;
  }

  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showSlide(i)));
  if (prev && next) {
    prev.addEventListener('click', () => showSlide((current - 1 + slides.length) % slides.length));
    next.addEventListener('click', () => showSlide((current + 1) % slides.length));
  }

  // 移动端触摸滑动 — Photos
  const photosView = document.getElementById('view-photos');
  let touchStartX = 0;
  let touchEndX = 0;
  if (photosView) {
    photosView.addEventListener('touchstart', e => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    photosView.addEventListener('touchend', e => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          showSlide((current + 1) % slides.length);
        } else {
          showSlide((current - 1 + slides.length) % slides.length);
        }
      }
    }, { passive: true });
  }

  // 移动端触摸滑动 — Accessories
  const accView = document.getElementById('view-accessories');
  let accTouchStartX = 0;
  let accTouchEndX = 0;
  if (accView) {
    accView.addEventListener('touchstart', e => {
      accTouchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    accView.addEventListener('touchend', e => {
      accTouchEndX = e.changedTouches[0].screenX;
      const diff = accTouchStartX - accTouchEndX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          renderAccPage((accPage + 1) % totalPages);
        } else {
          renderAccPage((accPage - 1 + totalPages) % totalPages);
        }
      }
    }, { passive: true });
  }
  // 自动隐藏无内容的标签
  const viewChecks = {
    'accessories': '#view-accessories .ulefone-accessory-item',
    'intro': '#view-intro img, #view-intro video, #view-intro iframe',
    '3d': '#view-3d model-viewer, #view-3d iframe'
  };

  Object.entries(viewChecks).forEach(([view, selector]) => {
    const hasContent = document.querySelector(selector);
    if (!hasContent) {
      const tab = document.querySelector(`.ulefone-dji-tab[data-view="${view}"]`);
      if (tab) tab.style.display = 'none';
    }
  });
  // 标签切换
  const tabs = document.querySelectorAll('.ulefone-dji-tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const view = tab.dataset.view;
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      ['photos','accessories','intro','3d'].forEach(v => {
        document.getElementById('view-' + v).classList.remove('active');
      });
      if (thumbnailsEl) thumbnailsEl.style.display = view === 'photos' ? 'flex' : 'none';
            const counter = document.querySelector('.ulefone-photo-counter');
      if (counter) counter.style.display = view === 'photos' ? 'block' : 'none';
      document.getElementById('view-' + view).classList.add('active');
    });
  });

  // 配件翻页（每页2个）
  const accItems = document.querySelectorAll('.ulefone-accessory-item');
  const accPrev = document.getElementById('acc-prev');
  const accNext = document.getElementById('acc-next');
  const accDots = document.getElementById('acc-dots');
  const pageSize = 2;
  let accPage = 0;
  const totalPages = Math.ceil(accItems.length / pageSize);

  function renderAccPage(page) {
    accItems.forEach((item, i) => {
      item.classList.toggle('acc-visible', i >= page * pageSize && i < (page + 1) * pageSize);
    });
    if (accDots) {
      accDots.innerHTML = '';
      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('span');
        dot.className = 'ulefone-acc-dot' + (i === page ? ' active' : '');
        accDots.appendChild(dot);
      }
    }
    accPage = page;
  }

  if (accItems.length > 0) {
    renderAccPage(0);
    if (accPrev) accPrev.addEventListener('click', () => renderAccPage((accPage - 1 + totalPages) % totalPages));
    if (accNext) accNext.addEventListener('click', () => renderAccPage((accPage + 1) % totalPages));
  }

  // 配件加购
  document.querySelectorAll('.ulefone-acc-hotspot[data-variant-id]').forEach(hotspot => {
    hotspot.addEventListener('click', function() {
      const variantId = this.dataset.variantId;
      const btn = this.querySelector('.ulefone-acc-cart-btn');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => {
        if (btn) btn.innerHTML = '✓';
        setTimeout(() => {
          if (btn) btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 001.99 1.61h9.72a2 2 0 001.99-1.61L23 6H6"/></svg>';
        }, 1500);
      })
      .catch(() => alert('加购失败，请重试'));
    });
  });

});
  } catch(e) { console.error(e); }
})();

})();
